/**
 * =========================================================================================
 *     DOBLER DATA SOLUTIONS, LLC - PROPRIETARY AND CONFIDENTIAL
 * =========================================================================================
 * The source code contained herein is owned by Dobler Data Solutions, LLC. The source code
 * and all other copyrightable materials related thereto, including without limitation, all
 * text, logos, designs, graphics, other files, and other code, is protected under Title 17
 * of the United States Code. Any use, including any commercial use, distribution,
 * republication, or display of the source code or any other copyrightable materials related
 * thereto is strictly prohibited. Copyright © 2026 Dobler Data Solutions, LLC.
 * ALL RIGHTS RESERVED.
 * =========================================================================================
 *
 *     File Name       :   App.tsx
 *     Description     :   Root application component — composes AuthProvider with the AppRouter.
 *     Module          :   005-web-shell
 *     Component Type  :   Component
 *
 * -----------------------------------------------------------------------------------------
 *     CHANGE HISTORY
 * -----------------------------------------------------------------------------------------
 *     Version     Date            Author              Description
 * -----------------------------------------------------------------------------------------
 *     1.0         2026-06-23      Peter Dobler        Initial creation
 * -----------------------------------------------------------------------------------------
 *
 *     DEPENDENCIES
 * -----------------------------------------------------------------------------------------
 *     External        :   react
 *     Internal        :   AuthProvider AppRouter
 *
 *     EXPORTS
 * -----------------------------------------------------------------------------------------
 *     App
 *
 * =========================================================================================
 */

import { AuthProvider } from "./auth/AuthProvider.js";
import { UserProvider } from "./auth/UserProvider.js";
import { AppRouter } from "./router.js";

/** Root application component. Wraps AuthProvider + UserProvider (role/preferences) and the router. */
export function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <UserProvider>
        <AppRouter />
      </UserProvider>
    </AuthProvider>
  );
}
